export default function TrueFlowLogo({ variant = "light", className = "", width = 130, height = 35 }) {
  if (variant === "dark") {
    return (
      <svg width={width} height={height} viewBox="0 0 310 84" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="True Flow">
        <g transform="translate(4,6)">
          <path d="M4,52 C24,52 52,18 82,10 L82,24 C52,32 24,66 4,66 Z" fill="#60A5FA" opacity="0.08"/>
          <path d="M4,52 C24,52 52,18 82,10" fill="none" stroke="#60A5FA" strokeWidth="3" strokeLinecap="round"/>
          <path d="M4,66 C24,66 52,32 82,24" fill="none" stroke="#60A5FA" strokeWidth="2" strokeLinecap="round" opacity="0.40"/>
          <circle cx="82" cy="10" r="11" fill="#F0C860" opacity="0.16"/>
          <circle cx="82" cy="10" r="7"  fill="#F0C860" opacity="0.34"/>
          <circle cx="82" cy="10" r="4"  fill="#F0C860"/>
          <circle cx="82" cy="24" r="3.5" fill="#60A5FA" opacity="0.40"/>
        </g>
        <line x1="110" y1="14" x2="110" y2="70" stroke="#1E293B" strokeWidth="1"/>
        <text x="124" y="40" fontFamily="-apple-system,'Segoe UI',Helvetica,Arial,sans-serif" fontSize="19" fontWeight="300" fill="#475569" letterSpacing="5">True</text>
        <text x="124" y="64" fontFamily="-apple-system,'Segoe UI',Helvetica,Arial,sans-serif" fontSize="19" fontWeight="800" fill="white" letterSpacing="1">Flow</text>
      </svg>
    );
  }
  return (
    <svg width={width} height={height} viewBox="0 0 310 84" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="True Flow">
      <g transform="translate(4,6)">
        <path d="M4,52 C24,52 52,18 82,10 L82,24 C52,32 24,66 4,66 Z" fill="#1A3A6C" opacity="0.07"/>
        <path d="M4,52 C24,52 52,18 82,10" fill="none" stroke="#1A3A6C" strokeWidth="3" strokeLinecap="round"/>
        <path d="M4,66 C24,66 52,32 82,24" fill="none" stroke="#1A3A6C" strokeWidth="2" strokeLinecap="round" opacity="0.40"/>
        <circle cx="82" cy="10" r="11" fill="#C49040" opacity="0.12"/>
        <circle cx="82" cy="10" r="7"  fill="#C49040" opacity="0.28"/>
        <circle cx="82" cy="10" r="4"  fill="#C49040"/>
        <circle cx="82" cy="24" r="3.5" fill="#1A3A6C" opacity="0.30"/>
      </g>
      <line x1="110" y1="14" x2="110" y2="70" stroke="#E2E8F0" strokeWidth="1"/>
      <text x="124" y="40" fontFamily="-apple-system,'Segoe UI',Helvetica,Arial,sans-serif" fontSize="19" fontWeight="300" fill="#64748B" letterSpacing="5">True</text>
      <text x="124" y="64" fontFamily="-apple-system,'Segoe UI',Helvetica,Arial,sans-serif" fontSize="19" fontWeight="800" fill="#1A3A6C" letterSpacing="1">Flow</text>
    </svg>
  );
}
